import { render } from "./PageWrapper.vue?vue&type=template&id=79b818c2"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"

import "./PageWrapper.vue?vue&type=style&index=0&id=79b818c2&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__